import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostListener,
    inject,
    input,
    viewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import {
    closeSideMenu,
    openSideMenu,
} from '../../store/actions/commonSettings.action';

import { selectSideMenuIsOpen } from '../../store/selectors/commonSettings.selector';
import { HeaderNavigation } from '../header/header.component';
import { MatRipple } from '@angular/material/core';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';

declare const window: any;
@Component({
    imports: [
        MatRipple,
        MatIcon,
        NgClass,
        TranslatePipe,
        RouterLink,
    ],
    selector: 'app-mobile-side-menu',
    styleUrls: ['./mobile-side-menu.component.scss'],
    templateUrl: './mobile-side-menu.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileSideMenuComponent {
    private store = inject(Store);

    navigation = input<HeaderNavigation[]>([]);

    navigationBlock = viewChild<ElementRef>('navigationBlock');
    isVisible = this.store.selectSignal(selectSideMenuIsOpen);


    @HostListener('document:mousedown', ['$event'])
    onGlobalClick(event: MouseEvent): void {
        const navBlock = this.navigationBlock();
        if (this.isVisible() && navBlock && !navBlock.nativeElement.contains(event.target)) {
            this.store.dispatch(closeSideMenu());
        }
    }

    openMenu() {
        this.store.dispatch(openSideMenu());
    }

    hideMenu() {
        this.store.dispatch(closeSideMenu());
    }

    openInNewTab(navItem: HeaderNavigation) {
        this.hideMenu();
        if (navItem?.url) {
            window.open(navItem.url, '_blank', 'noopener');
        }
    }
}
